// Mirrors _features/usageSources/state/slice.js's shape (selectedFilters
// only, REHYDRATE normalization) - does NOT carry forward the old
// features/usageCompilationFeature/slice.js's `usageCompilations` array
// mirror (write-only dead-sync - confirmed zero useSelector readers
// anywhere in the app) or its `customColumns` (also confirmed zero
// readers - the filters hook reads columns from local useState).
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const DEFAULT_SORT = "-createdAt";

const initialState = {
  selectedFilters: {
    sort: DEFAULT_SORT,
  },
};

const usageCompilationFeatureSlice = createSlice({
  name: "usageCompilationFeature",
  initialState,
  reducers: {
    updateSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters: (state) => {
      state.selectedFilters = {
        sort: DEFAULT_SORT,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.usageCompilationFeature) {
        const persistedData = action.payload.usageCompilationFeature;
        const persistedSort = persistedData.selectedFilters?.sort;

        return {
          ...state,
          ...persistedData,
          selectedFilters: {
            ...(persistedData.selectedFilters && typeof persistedData.selectedFilters === "object"
              ? persistedData.selectedFilters
              : {}),
            sort: persistedSort || DEFAULT_SORT,
          },
        };
      }
      return state;
    });
  },
});

export const { updateSelectedFilters, resetSelectedFilters } = usageCompilationFeatureSlice.actions;

export default usageCompilationFeatureSlice.reducer;
